import { VStack, Text, Center } from '@wegroup/design-system';
import React from 'react';
import { TertiaryButton } from 'wg-fe-ui';
import { useTranslation } from 'react-i18next';
import { FlowsQuestion } from '../../../../../types/FlowsTypes';
import useQuestionEnum from '../../../../../hooks/useQuestionEnum';

interface Props {
  question: FlowsQuestion;
  selected: string[];
  onSelected: (arg0: string[]) => void;
  error?: string;
}

const MultiSelectWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  question,
  selected,
  onSelected,
  error,
  children,
}) => {
  const { t } = useTranslation();

  const options = useQuestionEnum(question);

  const selectAll = () => {
    onSelected(options.map(({ value }) => value));
  };

  const deselectAll = () => {
    onSelected([]);
  };

  const isAllSelected =
    selected.every(
      (item) =>
        selected.length > 0 &&
        options?.map(({ value }) => value).includes(item.toString()),
    ) && selected.length > 0;

  return (
    <Center>
      <VStack align="flex-end" justify="stretch" spacing="4" pb="4">
        {error && (
          <Text alignSelf="center" color="danger.main">
            {error}
          </Text>
        )}
        <TertiaryButton
          onClick={isAllSelected ? deselectAll : selectAll}
          data-test-id="FLOWS_INPUT-COMPONENT_MULTI-SELECT_SELECT-ALL-BUTTON"
        >
          {isAllSelected ? t('Deselect all') : t('Select all')}
        </TertiaryButton>
        {children}
      </VStack>
    </Center>
  );
};

export default MultiSelectWrapper;
